<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body pb-10 pt-10 page-container">
          <div class="mb-4">
            <h4 class="mb-0">
              {{
                $t(
                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PAGE_MEMBER_DETAIL_TITLE"
                )
              }}
            </h4>
          </div>

          <b-tabs v-model="tabIndex" content-class="mt-3" @input="onTabInput">
            <b-tab
              :title="
                $t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.TAB_PROFILE')
              "
              lazy
            >
              <campaign-member-profile
                embed
                :campaign-id="campaignId"
                :customer-campaign-id="customerCampaignId"
              />
            </b-tab>
            <b-tab
              :title="
                $t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.TAB_POINTS')
              "
              lazy
            >
              <campaign-member-point-history
                embed
                :campaign-id="campaignId"
                :customer-campaign-id="customerCampaignId"
              />
            </b-tab>
            <b-tab
              :title="
                $t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.TAB_REDEMPTION')
              "
              lazy
            >
              <campaign-member-redemption-history
                embed
                :campaign-id="campaignId"
                :customer-campaign-id="customerCampaignId"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CampaignMemberProfile from "./CampaignMemberProfile.vue";
import CampaignMemberPointHistory from "./CampaignMemberPointHistory.vue";
import CampaignMemberRedemptionHistory from "./CampaignMemberRedemptionHistory.vue";

export default {
  name: "CampaignMemberDetail",
  components: {
    CampaignMemberProfile,
    CampaignMemberPointHistory,
    CampaignMemberRedemptionHistory
  },
  data() {
    return {
      tabIndex: 0
    };
  },
  computed: {
    campaignId() {
      return this.$route.params.campaignId;
    },
    customerCampaignId() {
      return this.$route.params.customerCampaignId;
    }
  },
  watch: {
    "$route.query.tab": {
      handler(val) {
        this.tabIndex = this.tabIndexFromQuery(val);
      }
    }
  },
  mounted() {
    this.tabIndex = this.tabIndexFromQuery(this.$route.query.tab);
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`,
        route: "/campaign"
      },
      {
        title: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TITLE")}`,
        route: `/campaign/form/campaign_receipt/${this.campaignId}`
      },
      {
        title: `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PAGE_MEMBER_DETAIL_TITLE"
        )}`
      }
    ]);
  },
  methods: {
    tabIndexFromQuery(tab) {
      const t = (tab != null ? String(tab) : "profile").toLowerCase();
      if (t === "points") {
        return 1;
      }
      if (t === "redemption") {
        return 2;
      }
      return 0;
    },
    queryNameFromTabIndex(idx) {
      const names = ["profile", "points", "redemption"];
      return names[idx] != null ? names[idx] : "profile";
    },
    onTabInput(idx) {
      const tab = this.queryNameFromTabIndex(idx);
      if (this.$route.query.tab === tab) {
        return;
      }
      this.$router
        .replace({
          query: { ...this.$route.query, tab }
        })
        .catch(() => {});
    }
  }
};
</script>
